import { useTranslation } from 'react-i18next';

export const useLocalizedPath = () => {
  const { i18n } = useTranslation();

  const getLocalizedPath = (path) => {
    if (i18n.language === 'en') {
      return path; // No prefix for English
    }
    // Ensure path starts with /
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    return `/${i18n.language}${normalizedPath}`;
  };

  const getPathWithoutLang = (path) => {
    // Remove language prefix from path
    const langPrefix = `/${i18n.language}`;
    if (path.startsWith(langPrefix)) {
      return path.slice(langPrefix.length) || '/';
    }
    return path;
  };

  return {
    getLocalizedPath,
    getPathWithoutLang,
    currentLanguage: i18n.language,
    isEnglish: i18n.language === 'en'
  };
};

export default useLocalizedPath;
